import { render } from "./TableCrud.vue?vue&type=template&id=8bf45608&scoped=true"
import script from "./TableCrud.vue?vue&type=script&lang=js"
export * from "./TableCrud.vue?vue&type=script&lang=js"

import "./TableCrud.vue?vue&type=style&index=0&id=8bf45608&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf45608"]])

export default __exports__